import cloneDeep from "clone-deep";
import { useCallback } from "react";
import { usePanelAccommodationContext } from "../../../context.js";
import { checkSelectedOptions } from "../../../utils.js";
const usePanelAccommodationPerson = (roomIndex, personIndex)=>{
    const { rooms , people , onChange  } = usePanelAccommodationContext();
    const onValueChange = useCallback((newValue)=>{
        const newRooms = cloneDeep(rooms);
        newRooms[roomIndex].people[personIndex].value = newValue;
        newRooms[roomIndex].people[personIndex].selectedOptions = checkSelectedOptions(people[personIndex], newRooms[roomIndex].people[personIndex]);
        onChange(newRooms);
    }, [
        rooms,
        people,
        personIndex,
        roomIndex,
        onChange
    ]);
    const onSelectOption = useCallback((selectedOptionIndex, newValue)=>{
        const newRooms = cloneDeep(rooms);
        newRooms[roomIndex].people[personIndex].selectedOptions[selectedOptionIndex] = newValue.value;
        onChange(newRooms);
    }, [
        onChange,
        personIndex,
        roomIndex,
        rooms
    ]);
    return {
        people,
        onValueChange,
        onSelectOption
    };
};
export default usePanelAccommodationPerson;

//# sourceMappingURL=usePanelAccommodationPerson.js.map